












import Vue from "vue";
import TestCaseForm from "@/components/TestCaseForm.vue";

export default Vue.extend({
  components: {
    TestCaseForm
  },
  props: {
    testCase: {
      type: Object,
      required: true
    }
  },
  methods: {
    save(attrs: Object) {
      this.$store
        .dispatch("updateTestCase", {
          testCase: this.testCase,
          attrs
        })
        .then(() => {
          this.close();
        });
    },
    remove() {
      let message = `Are you sure you want to delete test case "${this.testCase.attrs.title}"?`;
      if (confirm(message)) {
        this.$store.dispatch("deleteTestCase", this.testCase.id);
        this.close();
      }
    },
    close() {
      this.$emit("close");
    }
  }
});
